// extracted by mini-css-extract-plugin
module.exports = {"label":"WarnForm-label-52cfe63c89c234c30a23f7cddc078ec6","required":"WarnForm-required-17eae30694427a0c6a0665ae1a14f78b"};